<template>
	<div class="page">
		<div class="video-container">
			<video playsInline autoplay="autoplay" muted loop>
				<source v-if="$root.isMobile" src="/videos/mobile_homeScreen.mp4" type="video/mp4">
				<source v-else src="/videos/desktop_homeScreen.mp4" type="video/mp4">
				Your browser does not support the video tag.
			</video>
		</div>
		<div class="page-inner">
			<h1>
				SEEK<br>
				<span>Sleepmix</span>
			</h1>
			<div class="content-container">
				<p>A mix of tailored career advice and music to help you sleep easy</p>
				<transition name="bounce">
					<div v-if="bounce" :class="['button-container', {'button-bounce': buttonpressed === 1}, {'button-pulse': buttonpulse}]">
						<button @click="$root.spotifyLogin(() => { getTopGenres(); gaEvent('Landing Page', 'Clicked Connect with Spotify'); enter(1); })">
							Connect to Spotify
						</button>
					</div>
				</transition>
				<transition name="bounce">
					<div v-if="bounce" :class="['button-container', {'button-bounce': buttonpressed === 2}, {'button-pulse': buttonpulse}]">
						<button @click="gaEvent('Landing Page', 'Clicked Skip'); enter(2)">
							Continue without connecting
						</button>
					</div>
				</transition>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			fadeInContent: false,
			bounce: false,
			buttonpressed: false,
			buttonpulse: true,
		}
	},
	created() {
		const cookies = localStorage.getItem('cookiesAccepted');
		localStorage.clear();
		if (cookies) localStorage.setItem('cookiesAccepted', true);
	},
	mounted() {
		this.bounce = true;
	},
	methods: {
		async getTopGenres() {
			try {
				const res = await axios.get('/spotify/genres/top');
				const topGenres = res.data.genres;

				let maxGenres = 3;
				let genreCount = 0;

				let genres = ['pop','indie', 'hip-hop', 'dance', 'rock', 'r-n-b'];
				let seedGenres = [];

				for (let i = 0; i < topGenres.length; i++) {
					if (maxGenres === genreCount) {
						break;
					}
					for (let j = 0; j < genres.length; j++) {
						if (topGenres[i] === genres[j]) {
							seedGenres.push(genres[j])
							genreCount++;
						}
					}
				}

				if (seedGenres.length < 1) {
					seedGenres = ['pop'];
				}

				localStorage.setItem("seedGenres", JSON.stringify(seedGenres));
				console.log(seedGenres);

			} catch (err) {
				console.error(err);
				if (err.response) {
					console.error(err.response.data);
					this.$router.push({ name: 'error' });
				}
			}
		},
		enter(button) {
			this.buttonpulse = false;
			this.buttonpressed = button;
			setTimeout(() => {
				this.$router.push({ name: '2' });
			}, 400)
		}
	}
};
</script>

<style scoped>
button {
	background: #0e3980;
	display: flex;
    width: 20rem;
    height: 4.5rem;
    justify-content: center;
    align-items: center;
    transition: all 0.3s ease-in-out;
    border-radius: 1rem;
    padding: 1rem;
    margin: 0 1rem 1rem;
}

.desktop button {
	width: 16rem;
	margin: auto;
}

.button-container {
    height: 5.5rem;
}

.desktop .content-container {
	transform: translateY(3.5rem);
}

.mobile .page-inner {
	padding-bottom: 9rem
}

.mobile .button-container {
	height: 4.5rem;
}

.mobile button {
	height: 4rem;
}

button img {
	width: 100%;
}

.seek-logo {
	width: 15rem;
}

.seek-logo img {
	width: 100%;
}

h1 {
	color: #e70177;
	font-size: 9rem;
	text-align: center;
	line-height: 0.7;
}

h1 span {
	color: #e70177;
	font-size: 4.4rem;
	display: block;
	text-transform: capitalize;
}

.mobile h1 {
	font-size: 9rem;
}

.mobile h1 span {
	font-size: 4rem;
}

p {
	width: 20rem;
    margin: 1rem;
    text-align: center;
}
</style>
